import React from 'react';

const whatsappHref = "https://wa.me/971507163176?text=Hello!%20I'm%20interested%20in%20learning%20more%20about%20your%20corporate%20services.";

const FloatingWhatsApp = () => {
  return (
    <a
      href={whatsappHref}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="floating-whatsapp-button"
      className="fixed right-5 bottom-5 z-40 inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform duration-300 hover:scale-110 hover:bg-[#1FB855] focus:outline-none focus:ring-2 focus:ring-[#25D366] focus:ring-offset-2 focus:ring-offset-black"
    >
      <svg
        viewBox="0 0 32 32"
        className="h-7 w-7"
        fill="currentColor"
        aria-hidden="true"
        data-testid="floating-whatsapp-icon"
      >
        <path d="M16.04 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.6 4.48 1.73 6.44L3.2 28.8l6.55-1.72a12.77 12.77 0 0 0 6.28 1.65h.01c7.06 0 12.8-5.74 12.8-12.8 0-3.42-1.33-6.63-3.76-9.05A12.72 12.72 0 0 0 16.04 3.2Zm0 23.35h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-3.89 1.02 1.04-3.79-.25-.4a10.58 10.58 0 0 1-1.63-5.65c0-5.84 4.75-10.59 10.59-10.59 2.83 0 5.5 1.1 7.49 3.1a10.53 10.53 0 0 1 3.1 7.49c0 5.84-4.75 10.59-10.64 10.59Zm5.8-7.9c-.31-.16-1.83-.9-2.12-1-.28-.1-.49-.16-.69.16-.2.31-.79 1-.96 1.2-.18.2-.36.23-.67.08-.31-.16-1.31-.48-2.5-1.52-.93-.83-1.55-1.85-1.73-2.17-.18-.31-.02-.48.13-.63.14-.14.31-.36.47-.54.16-.18.21-.31.31-.51.1-.2.05-.39-.03-.54-.08-.16-.69-1.67-.95-2.29-.25-.6-.5-.52-.69-.53h-.59c-.2 0-.51.08-.77.39-.26.31-1 1-1 2.44 0 1.44 1.03 2.83 1.18 3.02.16.2 2.03 3.11 4.92 4.35.69.3 1.24.48 1.66.62.7.22 1.34.19 1.85.11.56-.08 1.83-.75 2.09-1.47.26-.72.26-1.34.18-1.47-.08-.12-.28-.2-.59-.36Z" />
      </svg>
    </a>
  );
};

export default FloatingWhatsApp;
